export default __webpack_public_path__ + "static/media/no-students.11b0d55e.svg";